export default function getResource(label, vars = []) {
    const resources = {
        productImage: 'Image de l’article'
    };

    return resources[label];
}
